import { user, users } from '@constants/endpoints';
import {
  DefaultReturnProps,
  EnterPhoneFormInputs,
  GetUser,
  SendOtp,
  VerifyOtp,
} from '@utils/types';
import { loginInstance } from './index';

export const searchUserByPhone = async (
  payload: EnterPhoneFormInputs,
): Promise<DefaultReturnProps | false> => {
  try {
    const response = await loginInstance.post(`${users}/search`, {
      mobile: payload.contactNumber,
    });

    return response.data ?? false;
  } catch (error) {
    return false;
  }
};

export const sendOtp: SendOtp = async (phoneNumber, otp_type = 'login') => {
  try {
    const response = await loginInstance.post(`/otps`, {
      mobile: phoneNumber,
      otp_type,
    });
    return response.data?.success ?? false;
  } catch (error) {
    return false;
  }
};

export const verifyOtp: VerifyOtp = async (userId, otp, otp_type = 'login') => {
  try {
    const response = await loginInstance.post(`/otps/verify`, {
      code: otp,
      otp_type,
      vendor_member_id: userId,
    });
    return response.data.success ? response.data : false;
  } catch (error) {
    return false;
  }
};

export const getUser: GetUser = async (userId) => {
  try {
    const response = await loginInstance.get(`${user}/${userId}`);
    return response.data ?? false;
  } catch (error) {
    return false;
  }
};
